export const selectFilterIcon = (filterOptions: any, setFilterOptions: any, social) => {
  if (!filterOptions.platform?.hasOwnProperty("in")) {
    setFilterOptions({ ...filterOptions, platform: { in: [social] } });
    return;
  }

  const second_social = social == "INSTAGRAM" ? "FACEBOOK" : "INSTAGRAM";
  const platform_in = Array.isArray(filterOptions?.platform?.in) ? filterOptions?.platform?.in : [];
  if (!platform_in?.includes(social)) {
    setFilterOptions({ ...filterOptions, platform: { in: [...platform_in, social] } });
  } else if (platform_in?.includes(second_social)) {
    setFilterOptions({
      ...filterOptions,
      platform: { in: platform_in?.filter((item) => item !== social) },
    });
  }
};
